import { render, staticRenderFns } from "./maintenance_item.vue?vue&type=template&id=60a48229&scoped=true&"
import script from "./maintenance_item.vue?vue&type=script&lang=js&"
export * from "./maintenance_item.vue?vue&type=script&lang=js&"
import style0 from "./maintenance_item.vue?vue&type=style&index=0&id=60a48229&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a48229",
  null
  
)

export default component.exports